//import Vue from 'vue'

const state = {
  showSideBar: true,
  colorMode: 'lightMode',
  originalMenu: [
    {name: 'Home', icon: 'home-alt', route: 'reports'},
    {name: 'Plantillas', icon: 'person-digging', route: 'templates'},
    {name: 'Empresas', icon: 'buildings', route: 'companies'},
    {name: 'Proyectos', icon: 'table-tree', route: 'projects'},
    {name: 'Archivos', icon: 'folder-tree', route: 'files'},
    {name: 'Usuarios', icon: 'home-alt', route: 'users'},
    {name: 'Roles', icon: 'users', route: 'roles'},
    {name: 'Cuarentena', icon: 'biohazard', route: 'quarantine'},
  ],
  menu: [
    {name: 'Home', icon: 'home-alt', route: 'reports'},
    {name: 'Plantillas', icon: 'person-digging', route: 'templates'},
    {name: 'Empresas', icon: 'buildings', route: 'companies'},
    {name: 'Proyectos', icon: 'table-tree', route: 'projects'},
    {name: 'Archivos', icon: 'folder-tree', route: 'files'},
    {name: 'Usuarios', icon: 'home-alt', route: 'users'},
    {name: 'Roles', icon: 'users', route: 'roles'},
    {name: 'Cuarentena', icon: 'biohazard', route: 'quarantine'},
  ],
  openedFolders: [],
}
const mutations = {
  toggleShowSideBar: (state) => (state.showSideBar = !state.showSideBar),
  toggleColorMode: (state,data) => (state.colorMode = data),
  setMenuByUser: (state, data) => (state.menu = data),
  setOpenedFolders: (state, data) => (state.openedFolders = data)
}
const actions = {
  toggleShowSideBar: (context) => (context.commit('toggleShowSideBar')),
  toggleColorMode: (context,data) => (context.commit('toggleColorMode',data))
}
const getters = {
  getShowSideBar: state => state.showSideBar,
  getColorMode: state => {
    switch(state.colorMode){
      case 'darkMode':
        return {
          globalBackground: 'gray',
          background: 'dark',
          text: 'light',
          sideBar: 'dark'
        }
      default:
        return {
          globalBackground: 'light',
          background: 'white',
          text: 'dark',
          sideBar: 'moby-white'
        }
    }
  },
  getOriginalMenu: state => state.originalMenu,
  getMenu: state => state.menu,
  getOpenedFolders: state => state.openedFolders,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
